'use client';

import { useMemo, useState } from 'react';
import { GlobalContext } from './contexts/GlobalContext';
import { ConfigurationTypeImages, DeliveryPeriod } from '../utils/interfaces';

export type GlobalContextProviderProps = {
  children: React.ReactNode;
  defaultDeliveryPeriod: DeliveryPeriod | undefined;
  defaultCmCorrelationId: string;
};

export const GlobalContextProvider = ({
  children,
  defaultDeliveryPeriod,
  defaultCmCorrelationId,
}: GlobalContextProviderProps) => {
  const [deliveryPeriod, setDeliveryPeriod] = useState<DeliveryPeriod | undefined>(defaultDeliveryPeriod);
  const [cmCorrelationId, setCmCorrelationId] = useState<string>(defaultCmCorrelationId);
  const [isManualSelectionDone, setIsManualSelectionDone] = useState<boolean>(false);
  const [isPreviewPanning, setIsPreviewPanning] = useState<boolean>(false);
  const [isPreviewZoomed, setIsPreviewZoomed] = useState<boolean>(false);
  const [configurationTypeImages, setConfigurationTypeImages] = useState<ConfigurationTypeImages>({});
  const [isUpsaleShown, setIsUpsaleShown] = useState<boolean>(false);
  const [toast, setToast] = useState<{ message: string; isOpen: boolean }>({ message: '', isOpen: false });

  const updateConfigurationTypeImages = (configurationTypeImages: ConfigurationTypeImages) => {
    setConfigurationTypeImages(prev => ({ ...prev, ...configurationTypeImages }));
  };

  const showToast = (message: string) => {
    setToast({ message, isOpen: true });
  };

  const hideToast = () => {
    setToast(prev => ({ ...prev, isOpen: false }));
  };

  const contextValue = useMemo(() => {
    return {
      isManualSelectionDone,
      setIsManualSelectionDone,
      deliveryPeriod,
      setDeliveryPeriod,
      configurationTypeImages,
      setConfigurationTypeImages,
      updateConfigurationTypeImages,
      cmCorrelationId,
      setCmCorrelationId,
      isUpsaleShown,
      setIsUpsaleShown,
      isPreviewPanning,
      setIsPreviewPanning,
      isPreviewZoomed,
      setIsPreviewZoomed,
      toast,
      showToast,
      hideToast,
    };
  }, [
    isManualSelectionDone,
    deliveryPeriod,
    configurationTypeImages,
    cmCorrelationId,
    isUpsaleShown,
    isPreviewPanning,
    isPreviewZoomed,
    toast,
  ]);

  return <GlobalContext.Provider value={contextValue}>{children}</GlobalContext.Provider>;
};
